<div class="support-box">
    <div class="support-body">
        <h2>Kontakt</h2>
        <p class="small">Hier finden Sie Ihren persönlichen Ansprechpartner.</p>
        <a [routerLink]="['/contact']" class="btn btn-primary small font-bold strict-sized-button mt-auto"
           (click)="onButtonClicked()">Kontakt</a>
    </div>

</div>


